import * as googleAnalytics from './googleAnalytics';
import * as utilities from './utilities';

declare global {
  interface Window {
    googleAnalytics: typeof googleAnalytics;
    utilities: typeof utilities;
  }
}

window.googleAnalytics = googleAnalytics;
window.utilities = utilities;